import {observable,action,computed} from "mobx"
import axios from "axios"


class BienStore{
  @observable elements = {
    "adresse": "",
    "numero": "",
    "pays": "Belgique",
    "cp": "",
    "ville": "",
    "boite": "",
    "remarque": "",
    "plusde10ans": false,
    "compteurgaz": "",
    "compteurelectricite": "",
    "compteureau": "",
    "compteureaufroide": "",
    "compteureauchaude": "",
    "meuble": false,
    "etages": "",
    "typedebien": "",
    "eauchaudfroidsepare": false,
    "gaz": true,
    "electricite": true
  }
  @observable expert = false
  @observable callBackExpert = null
  @observable pieces ={}
  @observable typesdepieces = []
  @observable locataires = []
  @observable user={}
  @observable current_piece_index = -1
  constructor(){
    if(localStorage.getItem('elements')==null){

    }else{
      this.elements = JSON.parse(localStorage.getItem('elements'))
    }
    if(localStorage.getItem('pieces')==null){

    }else{
      this.pieces = JSON.parse(localStorage.getItem('pieces'))
    }
    axios.get("/api/v1/gettypesdepiecesforusers",{}).then((data)=>{
      this.typesdepieces = data.data
    })
  }
  @computed get checkBaseElements(){
    let l = this.elements
    if(l["adresse"].length>2 && l["etages"]>0 && l["typedebien"].length>0 && l["numero"].length>0 && l["cp"].length >2 && l["ville"].length > 2 && l["pays"].length >2){
      return(true)
    }else{
      return(false)
    }
  }
  @computed get checkBienElements(){
    let l = this.elements
    if(1==1){
      return(true)
    }else{
      return(false)
    }
  }
  @action saveState(){
    if(this.elements !== undefined){
      localStorage.setItem('elements', JSON.stringify(this.elements));
    }
    if(this.pieces !== undefined){
      localStorage.setItem('pieces', JSON.stringify(this.pieces));
    }
  }
  @action saveToServer(){
    let pieces = []
    Object.keys(this.pieces).map((key)=>{
      pieces.push(this.pieces[key])
    })
    window.localStorage.clear()
    if(this.expert == true){
        this.callBackExpert({elements: this.elements,pieces: pieces})
    }else{
      axios.post("/api/v1/bien/add",{elements: this.elements,pieces: pieces}).then((data)=>{
        window.location.replace("/proprietaires/biens/index")
      }).catch((error)=>{
        alert('une erreur s\'est produite')
      })
    }
  }
}
let store = new BienStore()
global.BienStore = store
export default store
